import { useState } from "react"
import { useLegislationFromId } from "routes/schedule/plugins/guidance-tab/guidance-tab.runtime"
import { useCommitFunction } from "routes/schedule/compare/use-commit-function"
import { Box, ListItemText, Typography } from "@mui/material"
import { DifferenceWrapper } from "routes/schedule/compare/differenceWrapper"
import { PropertyBox } from "lib/@components/property-box"
import { ListItemBox } from "lib/@components/ListItemBox"
import { StatusButton } from "routes/schedule/compare/status"
import { AcceptedChanged, IsAccepted } from "event-definitions"
import { noChange } from "lib/@hooks/useRefresh"

export function NewGuidance({ guidance }) {
    const [remove, setRemoved] = useState(false)
    const legislation = useLegislationFromId(guidance)
    const accepted = IsAccepted.call({ isAccepted: false, id: "Guidance" })
    AcceptedChanged.after.useRefresh(noChange)
    useCommitFunction(
        (target) => {
            const idx = target.legislation.findIndex((id) => id.toString() === guidance.toString())
            if (idx !== -1) target.legislation.splice(idx, 1)
        },
        remove,
        [guidance]
    )

    return (
        !!legislation && (
            <ListItemBox ml={2} pr={2} className="new-guidance">
                <PropertyBox spacing={0}>
                    <DifferenceWrapper
                        label={`${remove ? "Removed" : "added"} guidance "${legislation.HTML}"`}
                        wrapper={<Box sx={{ py: 1, ml: -1 }} />}
                    >
                        <ListItemBox>
                            <ListItemText
                                disableTypography
                                sx={{ flex: 1, pl: 0 }}
                                primary={
                                    <Box sx={{ textDecoration: remove ? "line-through" : undefined }}>
                                        {legislation.HTML}
                                    </Box>
                                }
                                secondary={
                                    <Box>
                                        <Typography variant="body2">
                                            {!remove ? "New reference" : "Removed reference"}
                                        </Typography>
                                    </Box>
                                }
                            />
                            {!accepted && (
                                <StatusButton
                                    copied={remove}
                                    copy={() => setRemoved(!remove)}
                                    revert={() => setRemoved(!remove)}
                                />
                            )}
                        </ListItemBox>
                    </DifferenceWrapper>
                </PropertyBox>
            </ListItemBox>
        )
    )
}
